import { IDataAccessor } from "@core/data-access";
import { IAuthorizedPageObjectTreeService } from "@modules/basic/page";
import { ICartData } from "../model/domain/ICartData";
import { CartRestService } from "./cart-rest-service";


export class CartRestServicesV2Provider {

    constructor() { }

    public $get = ["$accessor", "$objectTree", function CartRestServiceV2Factory($accessor: IDataAccessor<ICartData>, $objectTree: IAuthorizedPageObjectTreeService) {
        return new CartRestService($accessor, $objectTree);
    }]
}